<template>
  <div class="d-flex flex-column" :style="{ width: '40px' }">
    <div
      v-if="days !== null && days !== undefined && (context ? days != 0 : true)"
      :style="
        context ? actionsTakenColorIndicator() : lastChangeColorIndicator(days)
      "
    >
      {{ days }}
    </div>
    <p v-if="action_date" class="text-muted">
      {{ $t('job.action') }}: {{ $moment(action_date).format('L') }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    days: Number,
    context: {
      type: String,
      default: '',
    },
    action_date: String,
  },
  methods: {
    lastChangeColorIndicator(daysPassed = 0) {
      const size = '40px';
      let bgcolor = '#04a789'; // gidGreen
      let color = 'white';
      if (daysPassed > 3) {
        bgcolor = 'orange';
        color = 'black';
      }
      if (daysPassed > 6) {
        bgcolor = 'red';
        color = 'black';
      }
      return `background-color:${bgcolor};
        color:${color};
        border-radius: ${size};
        width:${size};
        height:${size};
        text-align:center;
        line-height:${size};
        margin:0;`;
    },
    actionsTakenColorIndicator() {
      return `
        background-color:#2D83FF;
        color: black;
        width: 40px;
        height: 40px;
        border-radius: 40px;
        text-align: center;
        line-height: 40px;
        margin: 0;
      `;
    },
  },
};
</script>
